import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import WorkflowForm from './WorkflowForm';
import ListWorkflow from './ListWorkflow';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import ParentDocCard from '../../../common/ParentDocCard';
import { isProjectReadOnly } from '../../../../common/utils/api_utils';

export default class WorkflowBuilder extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    workflows: PropTypes.array,
    collection: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
  };

  state = {
    roles: {},
    collectionItems: {},
  };

  componentDidMount() {
    const { projectId, version } = this.props;
    const uri = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/role`;
    const header = builderSurfaceJsonContentHeader(projectId);
    const doRequest = axios.get(uri, header);
    doRequest.then((res) => {
      this.setState({ roles: res.data });
    });
    this.fetchCollectionItems();
  }

  fetchCollectionItems() {
    const { projectId, collection, version } = this.props;
    const uri = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collection.collectionName}`;
    const header = builderSurfaceJsonContentHeader(projectId);
    const doRequest = axios.get(uri, header);
    doRequest.then((res) => {
      this.setState({ collectionItems: res.data });
    });
  }

  handleSubmit = (values) => {
    const { projectId, collection, version } = this.props;
    this.props.actions.addWorkflowToCollection({
      projectId,
      version,
      collectionUuid: collection.uuid,
      data: values,
    });
  };

  render() {
    const {
      actions,
      collection,
      projectId,
      version,
      workflows,
      collections,
      showWorkflowDeleteLoader,
    } = this.props;
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <div className="row mx-auto">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('form')}`}></i>
                </div>
                <div className="card-content">
                  <h5 className="card-title mb-0 pb-0">
                    Add Workflow{' '}
                    {typeof collection !== 'undefined' && collection
                      ? ' To ' + collection.collectionTitle
                      : ''}
                  </h5>

                  <p>Add workflows to ensure that only valid data gets saved in a collection.</p>
                  <WorkflowForm
                    actions={actions}
                    collection={collection}
                    projectId={projectId}
                    collections={collections}
                    roles={this.state.roles}
                    collectionItems={this.state.collectionItems}
                    handleSubmit={this.handleSubmit}
                    isReadOnly={isReadOnly}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('list')}`}></i>
                </div>
                <div className="card-content">
                  <h5 className="card-title">Workflows</h5>
                  <ListWorkflow
                    workflows={workflows}
                    version={version}
                    actions={actions}
                    projectId={projectId}
                    collection={collection}
                    showWorkflowDeleteLoader={showWorkflowDeleteLoader}
                    isReadOnly={isReadOnly}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ParentDocCard>
          <h5>
            <b>About Workflow</b>
          </h5>
          <p>
            Allows you to apply a workflow to ensure that only valid data gets saved in collection.
            To apply a workflow, you first have to create them.
          </p>
        </ParentDocCard>
      </div>
    );
  }
}
